// src/com/sms_sent/SmsSentGql.js
import {gql} from '@apollo/client';


/*

extend type Query {
    smsSentList(dateFrom: String): [SmsSentGroupByCust]!
    smsSentListOverCust(custId: String!, dateFrom: String): [SmsSent]!
}


type SmsSentGroupByCust {
    tranDate: String!
    custId: String!
    custName: String
    smsLen: Int
}

type SmsSent {
    sentId: Int!
    tranDate: String!
    custId: String!
    custName: String
    tranId: String
    tranPhone: String
    callBack: String
    message: String
    etc3: String
}

*/

// 고객아이디로 GroupBy된 1개월 동안의 문자전송 카운트.
export const GET_SMS_SENT_LIST = gql`
    query getSmsSentList($dateFrom: String) {
        smsSentList(dateFrom: $dateFrom) {
            tranDate
            custId
            custName
            smsLen
        }
    }
`;

// 특정 고객의 1개월 동안의 문자전송 내역.
export const GET_SMS_SENT_LIST_OVER_CUST = gql`
    query getSmsSentListOverCust($custId: String!, $dateFrom: String) {
        smsSentListOverCust(custId: $custId, dateFrom: $dateFrom) {
            sentId
            tranDate
            custId
            custName
            tranId
            tranPhone
            callBack
            message
            etc3
        }
    }
`;
